<!-- Bouton qui ouvre la modale -->
<button
  class="upload-button button button--{{buttonSize}}"
  (click)="openUploadModal()"
  type="button"
>
  <i class="fa-solid fa-upload"></i>
  {{ label | transloco }}
</button>

<!-- Modale -->
<app-modal [open]="uploadModalOpened" (closed)="closeUploadModal()">
  <div modal-header>
    <h2>{{ 'upload-image.modal.title' | transloco }}</h2>
  </div>

  <div modal-body class="upload-image-modal">
    <!-- Hidden file input (click programmatically or click on dropzone) -->
    <input
      #fileInput
      type="file"
      accept="image/*"
      [attr.multiple]="allowMultipleSelection ? '' : null"
      (change)="onFilesPicked($event)"
      hidden
    />

    <!-- Dropzone: click to open picker, supports DnD -->
    <div
      class="upload-image-modal__drag-and-drop-zone"
      [class.is-dragging]="isDraggingOver"
      (click)="triggerPick()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
      (drop)="onDrop($event)"
    >
      <p class="upload-image-modal__drag-and-drop-zone__label">
        {{ 'upload-image.modal.drag-and-drop' | transloco }}
      </p>
    </div>

    <!-- Info limite -->
    @if (maxNumberOfImages !== null) {
      <p class="upload-image-modal__max-number-of-images">
        {{ 'upload-image.modal.max-number-of-images' | transloco:{ number: maxNumberOfImages } }}
      </p>
    }

    <!-- Liste des images sélectionnées (queue) -->
    @if (queue.length > 0) {
      <div class="upload-image-modal__image-list">
        @for (it of queue; track it) {
          <div class="upload-image-modal__image-list__item {{ statusClass(it) }}">
            <div class="upload-image-modal__image-list__thumb">
              @if (it.previewUrl) {
                <app-image
                  [src]="it.previewUrl"
                  [alt]="it.name"
                  preset="avatar"
                  aspectRatio="1/1"
                  [width]="80"
                  [height]="80"
                ></app-image>
              }
            </div>

            <div class="upload-image-modal__image-list__details">
              <span class="upload-image-modal__image-list__name" [title]="it.name">{{ it.name }}</span>
              <span class="upload-image-modal__image-list__meta">
                {{ formatSize(it.sizeMb) }}
                @if (it.batchIndex !== undefined) {
                  · {{ 'upload-image.modal.batch.short' | transloco:{ index: it.batchIndex + 1 } }}
                }
              </span>
              <span class="upload-image-modal__image-list__status">
                {{ statusLabel(it) }}
              </span>
            </div>

            <button
              class="upload-image-modal__image-list__remove"
              type="button"
              (click)="removeFromQueue(it)"
              aria-label="Remove image"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        }
      </div>
    }

    @if (informationMessages.length > 0) {
      <div class="upload-image-modal__infos" role="status">
        @for (message of informationMessages; track $index) {
          <div class="upload-image-modal__infos__item">
            <i class="fa-solid fa-circle-info"></i>
            <span>{{ message }}</span>
          </div>
        }
      </div>
    }

    @if (totalBatches > 0) {
      <div class="upload-image-modal__progress" aria-hidden="true">
        <div class="upload-image-modal__progress__track">
          <div
            class="upload-image-modal__progress__fill"
            [style.width.%]="progressPercent()"
          ></div>
        </div>
      </div>
    }

    @if (warningMessages.length > 0) {
      <div class="upload-image-modal__warnings" role="alert">
        @for (message of warningMessages; track $index) {
          <div class="upload-image-modal__warnings__item">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <span>{{ message }}</span>
          </div>
        }
      </div>
    }
  </div>

  <div modal-footer>
    <div class="upload-image-modal__actions">
      <button class="button button--white" type="button" (click)="cancelUpload()">
        {{ 'upload-image.modal.cancel' | transloco }}
      </button>
      <button
        class="button button--primary"
        type="button"
        [class.button--loading]="isSubmitting"
        [disabled]="!queue.length || isSubmitting"
        (click)="onSubmit()"
      >
        {{ isSubmitting ? ('upload-image.modal.preparing' | transloco) : ('upload-image.modal.submit' | transloco) }}
      </button>
    </div>
  </div>
</app-modal>
